import CompanyService from '@/services/CompanyService';

import { companyMutationTypes } from './mutation-types';

export const actions = {
  addActiveCompany({ commit }, company) {
    commit(companyMutationTypes.SET_ACTIVE_COMPANY, company);
  },
  async getCompanies({ rootState, state, commit, dispatch }) {
    try {
      commit(companyMutationTypes.SET_REQUEST_STATUS, 'loading');

      if (state.companies && state.companies.length) {
        commit(companyMutationTypes.SET_REQUEST_STATUS, 'success');
        return state.companies;
      }

      const data = await CompanyService.getCompanies(rootState.user.user.id);

      commit(companyMutationTypes.SET_REQUEST_STATUS, 'success');
      commit(companyMutationTypes.SET_COMPANIES, data);

      if (data.length === 1) {
        dispatch('addActiveCompany', data[0]);
      }

      return data;
    } catch (e) {
      console.error(e);
      commit(companyMutationTypes.SET_REQUEST_STATUS, 'error');
    }
  },
};
